module.exports = __webpack_public_path__ + "img/icon-iosC-8.a1437715.png";